const toLocaleNumber = (n: number):string => {
  return  n.toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 2})
}


export default toLocaleNumber
